import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'apps/piqet-angular/src/environments/environment';
import { Observable } from 'rxjs/internal/Observable';

@Injectable({
  providedIn: 'root',
})
export class UserDetailsService {
  apiUrl = environment.url;
  public data: any;
  constructor(private http: HttpClient) {}

  loggedInUserProfileSummary() {
    return this.http.get<any>(`${this.apiUrl}/User/loggedInUserProfileSummary`);
  }

  userProfileOverview() {
    return this.http.get<any>(`${this.apiUrl}/UserProfile/UserProfileDetails`);
  }

  userPersonalInfo() {
    return this.http.get<any>(`${this.apiUrl}/UserProfile/userPersonalInfo`);
  }

  saveUserPersonalInfo(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/UserProfile/SaveUserPersonalInfo`, payload);
  }

  getUserProfileImage() {
    return this.http.get<any>(`${this.apiUrl}/UserProfile/UserProfileImage`);
  }

  updateUserProfileImage(payload: any) {
    return this.http.post<any>(`${this.apiUrl}/UserProfile/UpdateUserProfileImage`, payload);
  }

  getUserEmailPreferences() {
    return this.http.get<any>(`${this.apiUrl}/UserProfile/GetUserEmailPreferences`);
  }

  updateUserEmailPreferences(payload: any) {
    return this.http.get<any>(
      `${this.apiUrl}/UserProfile/UpdateUserEmailPreferences?isnotify=${payload.isnotify}&userId=${payload.userId}`
    );
  }

  getOrganization() {
    return this.http.get<any>(`${this.apiUrl}/UserProfile/SelectOrganization`);
  }

  changeOrganization(payload: any) {
    return this.http.post<any>(
      `${this.apiUrl}/UserProfile/ChangeOrganization?organizationMembershipId=${payload.organizationMembershipId}&userId=${payload.userId}`,
      {}
    );
  }

  regenerateAccessToken(userId: any, deviceId?: string, ipAddress?: string) {
    let url = `${this.apiUrl}/Login/ReGenerateAccessToken/${userId}`;

    if (deviceId) {
      url += `/${deviceId}`;
      if (ipAddress) {
        url += `/${ipAddress}`;
      }
    }
    return this.http.get<any>(url);
  }
}
